import type { LucideIcon } from "lucide-react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

import { cn } from "@/shared/lib/cn";

interface PendingActionCardProps {
  title: string;
  subtitle: string;
  count: number;
  to: string;
  icon: LucideIcon;
  onNavigate: () => void;
}

export function PendingActionCard({
  title,
  subtitle,
  count,
  to,
  icon: Icon,
  onNavigate,
}: PendingActionCardProps) {
  return (
    <Link
      to={to}
      onClick={onNavigate}
      className={cn(
        "flex items-center gap-3 rounded-xl border border-transparent px-3 py-2.5 transition-colors",
        "hover:border-primary/40 hover:bg-primary/5",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30",
      )}
    >
      <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-warning/15 text-warning-foreground">
        <Icon className="size-5" strokeWidth={1.75} aria-hidden />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-xs font-semibold text-foreground">{title}</span>
        <span className="mt-0.5 block text-2xs text-muted-foreground">{subtitle}</span>
      </span>
      <span className="flex shrink-0 items-center gap-1">
        <span className="min-w-5 rounded-full bg-muted px-1.5 py-0.5 text-center text-3xs font-semibold text-foreground">
          {count}
        </span>
        <ChevronRight className="size-4 text-muted-foreground" aria-hidden />
      </span>
    </Link>
  );
}
